export const userRoles = {
  user: 'ROLE_USER',
  superAdmin: 'ROLE_SUPER_ADMINISTRATOR',
  support: 'ROLE_SUPPORT',
  manager: 'ROLE_MANAGER',
  accountant: 'ROLE_ACCOUNTANT',
  admin: 'ROLE_ADMINISTRATOR'
}
